import Vue from 'vue'
import axios from 'axios'
import baseUrl from '@/server/config'
import {Message, MessageBox} from 'element-ui'
import store from "../store"
import {getToken} from '@/utils/auth'
import router from '../router'
import qs from 'qs'

axios.defaults.timeout = 5000;
axios.defaults.baseURL = baseUrl.URL_EASYMOCK;
 
//http request 拦截器
axios.interceptors.request.use(
  config => {
    const token = store.state.token
    config.headers = {
      'Authorization': token ? 'Bearer ' + token : ''
    }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);

//响应拦截器即异常处理
axios.interceptors.response.use(
  response => {
    const res = response.data + '';
    const statusCode = response.status + '';
    
    if (statusCode != '200') {
      return Promise.reject(res)
    } else {
      return response
    }
}, err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 300:
            Message.error({
              'message': err.response.data.message,
              'showClose':true,
              'customClass': 'pop-class-error',
              'duration': 3000
            })
            console.log(JSON.stringify(err.response));
          break;
        case 400:
            // Message.error({
            //   'message': err.response.data.message,
            //   'showClose':true,
            //   'customClass': 'pop-class-error',
            //   'duration': 3000
            // })
            console.log(JSON.stringify(err.response));
          break;
        case 401:
            console.log('未授权，请重新登录')
          break;
        case 403:
            const token = store.state.token
            let hintMsg = '';

            if (token && token != 'false') {
              hintMsg = '其他设备已登录，请重新登录'
            } else{
              hintMsg = '请登录'
            }
            
            // Message.error({
            //   'message': hintMsg,
            //   'showClose':true,
            //   'customClass': 'pop-class-error',
            //   'duration': 3000
            // })

            store.commit('LOGOUT');
          break;
        case 404:
          // Message.error({
          //   'message': err.response.data.message,
          //   'showClose':true,
          //   'customClass': 'pop-class-error',
          //   'duration': 3000
          // })
          console.log('请求错误,未找到该资源')
          break;
        case 405:
          console.log('请求方法未允许')
          break;
        case 408:
          console.log('请求超时')
          break;
        case 500:
          Message.error({
            'message': err.response.data.message,
            'showClose':true,
            'customClass': 'pop-class-error',
            'duration': 3000
          })
          console.log('服务器端出错')
          break;
        case 501:
          console.log('网络未实现')
          break;
        case 502:
          console.log('网络错误')
          break;
        case 503:
          console.log('服务不可用')
          break;
        case 504:
          console.log('网络超时')
          break;
        case 505:
          console.log('http版本不支持该请求')
          break;
        default:
          console.log(`连接错误${JSON.stringify(err.response)}`)
      }
      console.log(`连接错误${JSON.stringify(err)}`)
    } else {
      console.log('连接到服务器失败'+JSON.stringify(err));
    }
    return Promise.reject(err.response)
})


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export function post(url,data = {}){
   return new Promise((resolve,reject) => {
     axios.post(url,data)
          .then(response => {
            resolve(response.data);
          },err => {
            reject(err)
          })
   })
 }


 /**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export function postFile(url,data = {}) {
   let config = {
    headers: {'Content-Type': 'multipart/form-data'}
   }
 
   return new Promise((resolve,reject) => {
     axios.post(url,data,config)
        .then(response => {
          resolve(response.data);
        },err => {
          reject(err);
        })
   })
 }



 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.patch(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.put(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

 /**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function deleteData(url, params = {}){
  return new Promise((resolve,reject) => {
    axios.delete(url,{params:params})
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}


 /**
 * 统一封装请求数据方式
 * @param url 地址
 * @param method 请求方式
 * @param params 参数
 * @returns {Promise}
 */

 const httpReq = (url,method,params) => {
  // let userInfo = getUserInfo();
  // let userToken = getToken();

  // let sign = {
  //   type: 'liveconsole',
  //   user_id: '0',
  //   token: userToken || '0'
  // };
  // console.log(userInfo);
  // if (userInfo && userInfo != 'false') {
  //   let userInfoObj = JSON.parse(userInfo);
  //   sign.user_id = userInfoObj.id;
  // }
  
  // params.sign = JSON.stringify(sign);
  const reqMode = method.toLowerCase();
  if (!params) {
    var params = {
      mars_light_client: 'web',
      mars_light_platform: 'web'
    }
  } else {
    params.mars_light_client = 'web';
    params.mars_light_platform = 'web';
  }

  switch(reqMode) {
    case 'get':
      return fetch(url,params);
      break;
    case 'post':
      return post(url,params);
      break;
    case 'delete':
      return deleteData(url,params);
      break;
    case 'patch':
      return patch(url,params);
      break;
    case 'put':
      return put(url,params);
      break;
    case 'postfile':
      return postFile(url,params);
      break;
  }
}

export default httpReq



// WEBPACK FOOTER //
// ./src/server/http.js